var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$flag ? 'anContact' : 'pcContact'},[_c('div',{staticClass:"top-img"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}})]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-box"},[_c('div',{attrs:{"id":"mapContainer"}}),_c('div',{staticClass:"map-address"},[_vm._v(" 地址：浙江省丽水市龙泉市龙渊街道滨江花园德馨居3幢公寓306室 ")])])
}]

export { render, staticRenderFns }